import { LicenseCategory } from "../../common/models/LicenseCategory";
import { LicenseCategoryResponse } from "../models/responses/LicenseCategoryResponse";

export const LicenseCategoryMapper = (data: LicenseCategoryResponse): LicenseCategory => {
  return {
    id: data._id,
    name: data.name
  }
}